<div class="title">
  <p-heading [size]="'x-large'" [tag]="'h3'">Personal Travel Transactions</p-heading>

  <p-link
    *ngIf="isSuperAdmin"
    [hideLabel]="(mediaMaxXs$ | async) ?? false"
    [iconSource]="'assets/icons/add.svg'"
    [variant]="'secondary'"
  >
    <a [routerLink]="'/personal-travel-transactions/create'">Create New Transaction</a>
  </p-link>
</div>

<p-divider aria-hidden="true" />

<section class="section">
  <div class="breadcrumbs">
    <p-link-pure [hideLabel]="true" [iconSource]="'assets/icons/arrow-left.svg'">
      <a [routerLink]="isSuperAdmin ? '/personal-travel-transactions' : '/personal-travel-budget'">
        {{ isSuperAdmin ? 'All Transactions' : 'My Budget' }}
      </a>
    </p-link-pure>

    <p-heading
      *ngrxLet="personalTravelTransaction$ | async as transaction"
      [size]="'large'"
      [tag]="'h4'"
    >
      <ng-container *ngIf="transaction">
        {{ transaction.user.firstName }} {{ transaction.user.lastName }} ({{
          transaction.dateUsed | date
        }})
      </ng-container>
      <ng-container *ngIf="!transaction" />
    </p-heading>
  </div>
</section>

<section class="section">
  <p-heading class="section-heading" [size]="'medium'" [tag]="'h4'">
    <div class="content">
      <p-icon [source]="'assets/icons/info.svg'" />
      <span>Transaction Details</span>
    </div>
  </p-heading>

  <ng-container
    *ngrxLet="
      personalTravelTransaction$ as transaction;
      error as transactionError;
      suspenseTpl: spinner
    "
  >
    <div *ngIf="transactionError">
      <p-button-pure
        [hideLabel]="true"
        [iconSource]="'assets/icons/refresh.svg'"
        [size]="'large'"
        (click)="reloadEvent()"
      >
        Reload Transaction Details
      </p-button-pure>
    </div>

    <div *ngIf="!transactionError && transaction" class="transaction-details">
      <div>
        <p-text [weight]="'semi-bold'">Person:</p-text>
        <p-text>{{ transaction.user.firstName }} {{ transaction.user.lastName }}</p-text>
      </div>

      <div>
        <p-text [weight]="'semi-bold'">Trip Purpose:</p-text>
        <p-text>{{ transaction.tripPurpose?.description }}</p-text>
      </div>

      <div>
        <p-text [weight]="'semi-bold'">Trip Date:</p-text>
        <p-text>{{ transaction.dateUsed | date }}</p-text>
      </div>

      <div>
        <p-text [weight]="'semi-bold'">Productive Reference Number / Link:</p-text>
        <p-text>
          <opa-maybe-url [url]="transaction.productiveLink" />
        </p-text>
      </div>

      <div>
        <p-text [weight]="'semi-bold'">Total Cost:</p-text>
        <p-text>
          {{ transaction.amountAfter - transaction.amountBefore | opaCurrency: null : true }}
        </p-text>
      </div>

      <div>
        <p-text [weight]="'semi-bold'">Remaining Budget:</p-text>
        <p-text>
          {{ transaction.amountAfter | opaCurrency }}
        </p-text>
      </div>

      <div>
        <p-text [weight]="'semi-bold'">Description:</p-text>
        <p-text>{{ transaction.description }}</p-text>
      </div>
    </div>
  </ng-container>
</section>

<ng-template #spinner>
  <div class="loading-spinner"><p-spinner /></div>
</ng-template>
